// src/NotFound.js
import React from 'react';
import { Link, Container,Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import keywordsData from '../lang/keywords.json';

const NotFound = ({ language }) => {

    return (
        <Container>
        <Box width="100%"  my={3}>
            <Link href="../../" color="inherit" className="animated-link">
              <HomeIcon />&nbsp;{language === 'ar' ? keywordsData.home_txt_ar : keywordsData.home_txt_en}
            </Link>
        </Box>
        <Box mt={4} mx={2} my={20} textAlign="center">
        <div>
            <h1 className='text-main-title'>{language === 'ar' ? keywordsData.page_not_found_title_ar : keywordsData.page_not_found_title_en}</h1>
            <p>{language === 'ar' ? keywordsData.page_not_found_desc_ar : keywordsData.page_not_found_desc_en}</p>
        </div>
        </Box>
        </Container>
    );
};

export default NotFound;